import { render, staticRenderFns } from "./TransferTable.vue?vue&type=template&id=6ad90658"
import script from "./TransferTable.js?vue&type=script&lang=js&external"
export * from "./TransferTable.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports